// A Custom Error Handler For The Drivn Application
export class Err extends Error {
    // The Name Of The Error
    name;
    // The Message For The Error
    message;
    // The Cause Of The Error
    cause;
    // The Related Variable For The Error (ex: email, password)
    relatedVar;
    // The Class Constructor
    constructor({ name, message, cause, relatedVar = "root", }) {
        super();
        this.name = name;
        this.message = message;
        this.cause = cause;
        this.relatedVar = relatedVar;
    }
}
export var Type;
(function (Type) {
    Type["VALIDATOR"] = "VALIDATOR";
    Type["MISSING_FIELD"] = "MISSING_FIELD";
    Type["MISSING_PERMISSIONS"] = "MISSING_PERMISSIONS";
    Type["UNKOWN"] = "UNKOWN";
})(Type || (Type = {}));
